import { useState } from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
  Divider,
} from "@mui/material";

import { darkColors } from "../../../theme/colors";
import englishTranslations from "../../../i18n/translations/en";
import PlanetXDescription from "../../utils/footer-text";
import SocialAccountBar from "../../utils/social-account-bar";
import GradientButton from "../../utils/gradient-button";
import SocialIconsWithText from "../../utils/social-icons";
import FieldLabel from "../../utils/field-label";
import FieldInput from "../../utils/field-input";
import Logo from "../../utils/logo";
import Headings from "../../utils/headings";
import useWindowHeight from "../../../hooks/window-size/use-window-height";
import useWindowWidth from "../../../hooks/window-size/use-window-width";
import HeroImage from "../../utils/hero-image";
import BackgroundContainer from "../../utils/background-container";
import { useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";
import WalletConnector from "../../utils/wallet-connector";
import TermsPrivacyLinks from "../../utils/terms-privacy-links";

// Assume these image paths are correct for your project structure

export default function ConnectWallet() {
  const navigate = useNavigate();
  const windowWidth = useWindowWidth();

  const isMobile = windowWidth < 1050;

  const handleIconClick = (url) => {
    window.open(url, "_blank");
    // Add additional logic for each icon as needed
  };

  const handleTextClick = () => {
    // Add logic for text click
    navigate(routes.home);
  };

  return (
    <BackgroundContainer>
      <Container maxWidth={false} sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            minHeight: "100vh",
            gap: 4,
            py: 4,
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              maxWidth: isMobile ? "100%" : "30%",
              ml: "6%",
              pr: isMobile ? 4 : 0,
              py: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between", // This spreads out the content
            }}
          >
            <Box>
              <Logo />
              <Box mt={isMobile ? 5 : "35%"}>
                <Headings
                  heading={englishTranslations.auth.connectWalletHeading}
                  subHeading={englishTranslations.auth.connectWalletSubHeading}
                />
              </Box>
              <Stack>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: isMobile ? 0 : 3,
                  }}
                >
                  <WalletConnector shouldNavigate={true}>
                    {({ handleOpenModal }) => (
                      <GradientButton
                        text={englishTranslations.auth.connectWallet}
                        onClick={handleOpenModal} // Use handleOpenModal here
                        width={isMobile ? "100%" : "90%"}
                      />
                    )}
                  </WalletConnector>
                </Box>
              </Stack>
            </Box>
            <Box sx={{ mt: "auto", pt: isMobile ? 0 : 4 }}>
              <SocialAccountBar
                text={englishTranslations.auth.skip}
                onIconClick={handleIconClick}
                onTextClick={handleTextClick}
                isMobile={isMobile}
              />
              <Divider sx={{ my: 2, background: darkColors.gray }} />
              <PlanetXDescription isMobile={isMobile} />
              <TermsPrivacyLinks />
            </Box>
          </Box>

          {/* Right Section - Hero Image */}

          <HeroImage />
        </Box>
      </Container>
    </BackgroundContainer>
  );
}
